import { Component } from '@angular/core';
import { Division } from 'src/shared/api';
import { MatDialog } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, NgControl } from '@angular/forms';
import { filter } from 'rxjs/operators';
import { DivisionDialogComponent } from 'src/shared/form-models/division/division-dialog/division-dialog.component';
import { divisionFormConfig } from 'src/shared/form-models/division/division.component';
import { animateList } from 'src/shared/animations';
import { CustomFormListAccessor } from 'src/shared/form-models/form-list-cva.component';
import { DivisionUploadDialogComponent } from 'src/shared/form-models/division/division-upload-dialog/division-upload-dialog.component';
import * as _ from 'lodash';

@Component({
	selector: 'rpfsa-division-list',
	templateUrl: './division-list.component.html',
	styleUrls: ['./division-list.component.scss'],
	animations: [animateList],
})
export class DivisionListComponent extends CustomFormListAccessor<Division> {
	emptyColumns = ['empty'];
	resultColumns = ['name', 'status', 'subdivisions', 'edit', 'delete'];

	constructor(
		public ngControl: NgControl,
		public fb: FormBuilder,
		private readonly dialog: MatDialog
	) {
		super(ngControl, fb, divisionFormConfig);
	}

	addDivision() {
		this.dialog
			.open<DivisionDialogComponent, never, FormGroup>(
				DivisionDialogComponent,
				{ width: '450px' }
			)
			.afterClosed()
			.pipe(filter((control) => !!control))
			.subscribe((control) => {
				(this.parent.get('array') as FormArray).insert(0, control);
			});
	}

	uploadDivisions() {
		this.dialog
			.open<DivisionUploadDialogComponent, 
				{
					divisions: FormGroup[]
				},FormGroup[]>(
				DivisionUploadDialogComponent,
				{ 
					width: '450px',
					data: { 
						divisions: _.cloneDeep(this.array.controls as FormGroup[])
					}
				}
			)
			.afterClosed()
			.pipe(filter((control) => !!control))
			.subscribe((control) => {
				this.array.clear();
				control.forEach((element: FormGroup) => {
					this.array.push(element);
				});
			});
	}

	editDivision(division: Division) {
		this.dialog
			.open<DivisionDialogComponent, Division, FormGroup>(
				DivisionDialogComponent,
				{
					width: '450px',
					data: division,
				}
			)
			.afterClosed()
			.pipe(filter((control) => !!control))
			.subscribe((control) => {
				(this.parent.get('array') as FormArray).setControl(
					this.findDivisionIndex(division),
					control
				);
			});
	}

	canDeleteDivision(division: Division) {
		return division.isAssignedToAJob
			? division.name + ' is assigned to a job and cannot be deleted.'
			: '';
	}

	findDivisionIndex(division: Division){
		return this.dataSource.data?.findIndex(d => d === division)
	}
}
